export type ChangePasswordIn = {
  currentPassword?: string | null
  password: string
}

import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

export const selfChangePassword = async (
  params: ChangePasswordIn
) => {
  const { body } = await api.post(
    "/users/self/change-password/",
    { body: params }
  )

  queryClient.invalidateQueries({
    queryKey: [CURRENT_USER_QUERY_KEY],
  })

  return body
}
